<script lang="ts">
export default {
  name: 'RadioGroup',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';

export interface RadioOption {
  label: string;
  value: string | number;
  disabled?: boolean;
}

const props = withDefaults(
  defineProps<{
    modelValue?: string | number;
    options: RadioOption[];
    disabled?: boolean;
    name?: string;
    layout?: 'horizontal' | 'vertical';
    class?: string;
  }>(),
  {
    disabled: false,
    layout: 'vertical',
    name: () => `radio-group-${Math.random().toString(36).slice(2, 11)}`,
  }
);

const emit = defineEmits<{
  'update:modelValue': [value: string | number];
}>();

const groupClasses = computed(() => {
  const classes = ['form-control'];
  
  if (props.layout === 'horizontal') {
    classes.push('flex flex-row gap-4');
  } else {
    classes.push('flex flex-col gap-2');
  }
  
  if (props.class) {
    classes.push(props.class);
  }
  
  return classes.join(' ');
});

const handleChange = (value: string | number) => {
  if (!props.disabled) {
    emit('update:modelValue', value);
  }
};
</script>

<template>
  <div :class="groupClasses">
    <label
      v-for="option in options"
      :key="String(option.value)"
      class="label cursor-pointer justify-start gap-2"
      :class="{ 'cursor-not-allowed opacity-50': disabled || option.disabled }"
    >
      <input
        type="radio"
        :name="name"
        class="radio"
        :class="{ 'radio-disabled': disabled || option.disabled }"
        :value="option.value"
        :checked="modelValue === option.value"
        :disabled="disabled || option.disabled"
        @change="handleChange(option.value)"
      />
      <span class="label-text text-sm">{{ option.label }}</span>
    </label>
  </div>
</template>
